import { useEffect, useState } from "react";

type UseRemainingAppTotalBudgetPropType = {
  appTotalBudget?: number;
  appTotalPackageBudget: number;
};

export const useRemainingAppTotalBudget = ({
  appTotalBudget,
  appTotalPackageBudget,
}: UseRemainingAppTotalBudgetPropType): { remainingAppTotalBudget: number } => {
  const [remainingAppTotalBudget, setRemainingAppTotalBudget] = useState(0);
  useEffect(() => {
    if (appTotalBudget) {
      const remaingBudget = appTotalBudget - appTotalPackageBudget;
      setRemainingAppTotalBudget(remaingBudget < 0 ? 0 : remaingBudget);
    }
  }, [appTotalBudget, appTotalPackageBudget]);

  return { remainingAppTotalBudget };
};
